export default __webpack_public_path__ + "static/logo-rotonde-cress-white-b9f8da72894053cdece42d89b96778c5.png";